import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

const PasswordReset = ({ token: propsToken }) => {
  // Получаем токен из props или из data-атрибута DOM-элемента
  const [token, setToken] = useState(propsToken);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    // Попытка получить токен из data-атрибута
    if (!token) {
      const rootElement = document.getElementById('root');
      if (rootElement && rootElement.getAttribute('data-token')) {
        setToken(rootElement.getAttribute('data-token'));
      }
    }
    
    // Проверка наличия токена
    if (!token) {
      console.error('Token is missing!');
    }
  }, [token]);

  const togglePasswordVisibility = (field) => {
    if (field === 'password') {
      setShowPassword(!showPassword);
    } else {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!token) {
      toast.error('Недопустимый токен для сброса пароля');
      return;
    }
    
    if (password !== confirmPassword) {
      toast.error('Пароли не совпадают!');
      return;
    }
    
    if (password.length < 6) {
      toast.error('Пароль должен содержать не менее 6 символов');
      return;
    }
    
    setLoading(true);
    
    try {
      const response = await axios.post('/session/update_password', {
        token,
        password,
      });

      if (response.data.success) {
        toast.success(response.data.message);
        setSuccess(true);
        setTimeout(() => {
          window.location.href = '/session/new';
        }, 3000);
      } else {
        toast.error(response.data.message || 'Произошла ошибка при обновлении пароля');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Произошла ошибка при обновлении пароля';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-blue-800 flex justify-center items-center p-4">
      <div className="py-8 px-8 bg-white rounded-2xl shadow-xl w-full max-w-sm">
        <h1 className="text-3xl font-bold text-center mb-4">Сброс пароля</h1>
        <p className="w-full text-center text-sm mb-8 font-semibold text-gray-700 tracking-wide">
          Пожалуйста, введите новый пароль.
        </p>

        {!success ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Новый пароль"
                className="block text-sm py-3 px-4 rounded-lg w-full border outline-blue-500"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => togglePasswordVisibility('password')}
                className="absolute right-4 top-3 text-gray-500"
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} size="lg" />
              </button>
            </div>

            <div className="relative">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder="Подтвердите пароль"
                className="block text-sm py-3 px-4 rounded-lg w-full border outline-blue-500"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => togglePasswordVisibility('confirm')}
                className="absolute right-4 top-3 text-gray-500"
              >
                <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} size="lg" />
              </button>
            </div>

            <button
              type="submit"
              className="w-full py-2 text-xl text-white bg-blue-800 rounded-lg hover:bg-blue-900 transition-all"
              disabled={loading}
            >
              {loading ? 'Загрузка...' : 'Обновить пароль'}
            </button>
          </form>
        ) : (
          <div className="text-center">
            <p className="text-green-600 font-semibold mb-4">
              Пароль успешно обновлен!
            </p>
            <p className="text-gray-600">
              Сейчас вы будете перенаправлены на страницу входа...
            </p>
          </div>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default PasswordReset; 